import AboutModalController from "./about_modal_controller"

// Opens the "Nastavenia cookies" modal (shared/cookie_consent/_modal) from the
// consent banner — signed out or in — and from the user menu.
//
// A subclass rather than a copy: the behaviour is exactly the about modal's
// (show imperatively because Bootstrap's data-api is not loaded here, tear
// down on turbo:before-cache so no backdrop or locked body scroll leaks into
// the page cache). What differs is only the identifier. The about modal is
// scoped to the user dropdown that owns it; this one sits on <body>
// (`data-controller="… cookie-consent"`), so a `click->cookie-consent#open`
// anywhere on the page — the banner above the navbar, the menu entry inside
// the dropdown — reaches the single modal the layout renders after <main>,
// which carries `data-cookie-consent-target="modal"`.
export default class extends AboutModalController {}
